import createReducer from 'utils/createReducer';
import { VEHICLE_STATES } from 'components/CarrierDetails/Constants';
import { DRIVER_STATES } from 'components/CarrierDetails/Constants';

// Initial State
const INIT_STATE = {
  currentCarrier: null,
  loading: false,
};

// Actions
const SET_CURRENT_CARRIER = 'carrier-section/SET_CURRENT_CARRIER';
const SET_LOADING = 'carrier-section/SET_LOADING';
const CREATE_OR_UPDATE_CARRIER_VEHICLE = 'carrier-section/CREATE_OR_UPDATE_CARRIER_VEHICLE';
const UPDATE_DRIVER = 'carrier-section/UPDATE_DRIVER';
const UPDATE_CARRIER = 'carrier-section/UPDATE_CARRIER';
const UPDATE_VEHICLE = 'carrier-section/UPDATE_VEHICLE';
const UPDATE_USER_FROM_DRIVER = 'carrier-section/UPDATE_USER_FROM_DRIVER';
const UPDATE_DOCUMENTS = 'carrier-section/UPDATE_DOCUMENTS';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_CURRENT_CARRIER](state, currentCarrier) {
    return {
      ...state,
      currentCarrier,
    };
  },
  [SET_LOADING](state, loading) {
    return {
      ...state,
      loading,
    };
  },
  [CREATE_OR_UPDATE_CARRIER_VEHICLE](state, vehicle) {
    return {
      ...state,
      currentCarrier: {
        ...state.currentCarrier,
        vehicles: state.currentCarrier.vehicles
          .filter((item) => item.id !== vehicle.id)
          .concat([vehicle])
          .filter((item) => item.status !== VEHICLE_STATES.removed),
      },
    };
  },
  [UPDATE_DRIVER](state, driver) {
    return {
      ...state,
      currentCarrier: {
        ...state.currentCarrier,
        drivers: state.currentCarrier.drivers
          .filter((item) => item.id !== driver.id)
          .concat([driver])
          .filter((item) => item.status !== DRIVER_STATES.removed),
      },
    };
  },
  [UPDATE_CARRIER](state, carrier) {
    delete carrier.drivers;
    delete carrier.vehicles;
    return {
      ...state,
      currentCarrier: {
        ...state.currentCarrier,
        ...carrier,
      },
    };
  },
  [UPDATE_DOCUMENTS](state, documents) {
    return {
      ...state,
      currentCarrier: {
        ...state.currentCarrier,
        documents,
      },
    };
  },
  [UPDATE_USER_FROM_DRIVER](state, { user, driverId }) {
    const oldDriver = state.currentCarrier.drivers.find((item) => item.id === driverId);
    return {
      ...state,
      currentCarrier: {
        ...state.currentCarrier,
        drivers: state.currentCarrier.drivers
          .filter((item) => item.id !== driverId)
          .concat([
            {
              ...oldDriver,
              user_set: [user],
              contact_name: `${user.first_name} ${user.last_name}`,
            },
          ])
          .filter((item) => item.status !== DRIVER_STATES.removed),
      },
    };
  },
});

// Action creators
export const setCurrentCarrier = (currentCarrier) => ({
  type: SET_CURRENT_CARRIER,
  payload: currentCarrier,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const createOrUpdateVehicle = (vehicle) => ({
  type: CREATE_OR_UPDATE_CARRIER_VEHICLE,
  payload: vehicle,
});

export const updateDriver = (driver) => ({
  type: UPDATE_DRIVER,
  payload: driver,
});

export const removeDriver = (driver, reason) => ({
  type: UPDATE_DRIVER,
  payload: driver,
  reason,
});

export const updateCarrier = (carrier) => ({
  type: UPDATE_CARRIER,
  payload: carrier,
});

export const removeCarrier = (carrier, reason) => ({
  type: UPDATE_CARRIER,
  payload: carrier,
  reason,
});

export const removeVehicle = (vehicle, reason) => ({
  type: UPDATE_VEHICLE,
  payload: vehicle,
  reason,
});

export const updateUserFromDriver = (payload) => ({
  type: UPDATE_USER_FROM_DRIVER,
  payload,
});

export const updateDocuments = (payload) => ({
  type: UPDATE_DOCUMENTS,
  payload,
});
